import { Component, OnInit } from '@angular/core';
import { SummaryComponent } from '../summary.component';
import { JobWorkOrderSummary } from '../../models/job.work.order.area.summary.interface';

@Component({
  selector: 'app-summary-mobile',
  templateUrl: './summary-mobile.component.html',
  styleUrls: ['./summary-mobile.component.scss']
})
export class SummaryMobileComponent extends SummaryComponent implements OnInit {

  jobWorkOrders: JobWorkOrderSummary[];

  ngOnInit(): void {
    super.init();   
  }

}
